<template>
  <div>
    <base-card-title underline expanded>
      {{ $t('inventory.title') }}
      <!-- <template #right>
          <base-dropdown label="Sort" />
        </template> -->
    </base-card-title>
    <base-breadcrumb v-if="!loading" :routes="routes" />

    <div class="catalog-single__grid">
      <template v-if="loading">
        <base-skeleton />
        <div>
          <base-skeleton />
        </div>
      </template>
      <template v-else>
        <catalog-product-images :images="item.images" />

        <div class="catalog-single__info">
          <div class="catalog-single__info__header">
            <!-- <base-heading v-if="item.brand" :level="3" class="mb-0">
              {{ item.brand.name }}
            </base-heading> -->
            <div class="serif-20">
              {{ item.brand.name }}
            </div>
            <div class="catalog-single__title">
              {{ item.title }}
            </div>
          </div>

          <hr class="my-0">

          <div class="serif-20">
            {{ item.formatted_price || item.price }}
          </div>

          <div class="catalog-single__facets">
            XS  |  S  |  M  |  L  |  XL  |  XXL  |  XXXL
          </div>

          <div class="catalog-single__facets">
            Regular  |  Short  |  Long  |  Gilets
          </div>

          <div class="catalog-single__detail">
            <p><strong>PRODUCT DETAILS</strong></p>
            <ul>
              <li>
                A bomber jacket in a herringbone silk,
                wool and cashmere blend.
                The design is highlighted with striped
                details at the sleeves and side zip pockets.
              </li>
              <li>
                Jacket length: 68.5cm/27in.
                This is based on a size UK M as proportions
                change slightly according to size.
              </li>
              <li>50% silk, 33% wool, 13% cashmere, 4% polyester</li>
              <li>Trims: 71% wool, 29% cashmere; 100% leather</li>
              <li>Two-way zip closure</li>
              <li>Side zip pockets</li>
              <li>Specialist dry clean</li>
              <li>Imported</li>
              <li>Item 80481331</li>
            </ul>
          </div>
          <div>
            <base-button class="pl-3" @click="openLink(item.site_url)">
              <base-icon icon="create-link" class="mr-2" />
              Preview Link - Website
            </base-button>
          </div>

          <!-- </div> -->
          <!-- The rest here -->
        </div>
      </template>
    </div>
  </div>
</template>

<script>

import CatalogProductImages from './CatalogProductImages';

export default {
  name: 'CatalogProductSingle',
  components: { CatalogProductImages },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {

    };
  },
  computed: {
    routes() {
      return [
        {
          name: this.$t('inventory.title'),
          link: '/inventory',
        },
        {
          name: this.item.title,
        },
      ];
    },
  },
  methods: {
    openLink(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.catalog-single{
    &__grid{
        width: 100%;
        display: grid;
        grid-template-columns: 400px 1fr;
        column-gap: 30px;
    }

    &__info{
        display: flex;
        align-items: flex-start;
        row-gap: 18px;
        flex-direction: column;
    }
    &__info__header{
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        gap: 10px;
    }

    &__title{
      //Silka/14px/Light
      @extend %silka-14-light;
    }
    &__facets{
      @extend %silka-16-light;
    }
    &__detail{
      @extend %silka-14-regular;
    }
}
</style>
